const SIGNALR_RECONNECT_DELAYS_MS = [0, 2000, 10000, 30000] as const;

/**
 * Gets the shared SignalR reconnect delays in milliseconds. This is used to configure the automatic reconnect policy for all SignalR connections in the app, ensuring consistent retry behavior across different real-time features.
 * @returns An array of numbers representing the reconnect delays in milliseconds.
 */
export const getSignalRReconnectDelaysMs = (): number[] => [...SIGNALR_RECONNECT_DELAYS_MS];